var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 225.662,
    height: 129.031,
    viewBox: "0 0 225.662 129.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_997",
    "data-name": "Groupe 997",
    transform: "translate(-853.943 -318.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1709",
    "data-name": "Trac\\xE9 1709",
    d: "M3039.4,351.249l-15.3,16.24-8.71-9.1h-29.76a10.039,10.039,0,0,1,.57-20.07,5.772,5.772,0,0,1,1.1.1,19.131,19.131,0,0,1,19.09-18.22,19.43,19.43,0,0,1,8.02,1.68l.88.35a6.294,6.294,0,0,0-4.08,3.65l-.33.28-.34-.1a13.729,13.729,0,0,0-4.12-.63,13.909,13.909,0,0,0-13.95,13.88,14.869,14.869,0,0,0,.18,2.31,2.689,2.689,0,0,1-.99,2.58,2.641,2.641,0,0,1-2.69.31,9.817,9.817,0,0,0-2.77-.97,2.535,2.535,0,0,0-.39,0,4.849,4.849,0,0,0,.39,9.69h32.36l5.54,5.82,11.1-11.83Z",
    transform: "translate(-2041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1710",
    "data-name": "Trac\\xE9 1710",
    d: "M2942.222,397.089c-7.64,0-15.89,5.63-15.89,14.73,0,9.33,6.53,15.84,15.89,15.84s15.85-6.52,15.85-15.84c.04-9.1-8.21-14.73-15.85-14.73m0,24.67a9.579,9.579,0,0,1-9.43-9.91c0-4.8,4.32-8.85,9.43-8.85s9.42,4.05,9.42,8.85a9.571,9.571,0,0,1-9.42,9.91",
    transform: "translate(-2041)",
    fill: "#312b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1711",
    "data-name": "Trac\\xE9 1711",
    d: "M2973.8,398.119h-10.3v28.57h10.3a14.285,14.285,0,0,0,0-28.57m-1.52,23.6v.02h-2.64v-18.7h2.71c5.77,0,9.51,3.66,9.51,9.34,0,6.88-4.95,9.34-9.58,9.34",
    transform: "translate(-2041)",
    fill: "#312b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1712",
    "data-name": "Trac\\xE9 1712",
    d: "M2993.71,426.686h15.514v-4.944h-9.365V414.8h8.882v-4.944h-8.882v-6.791h9.365V398.09H2993.71Z",
    transform: "translate(-2041)",
    fill: "#312b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1713",
    "data-name": "Trac\\xE9 1713",
    d: "M2922.906,403.708l-3.835,3.661a11.9,11.9,0,0,0-8.827-4.144,9.673,9.673,0,0,0-9.8,9.545q0,.144,0,.288a10.3,10.3,0,0,0,1.26,5.126,8.928,8.928,0,0,0,3.55,3.51,10.3,10.3,0,0,0,5.1,1.276,10.509,10.509,0,0,0,4.366-.887,15.762,15.762,0,0,0,4.358-3.257l3.724,3.89a20.334,20.334,0,0,1-6.046,4.327,16.447,16.447,0,0,1-6.5,1.2,14.952,14.952,0,0,1-11.013-4.263,14.759,14.759,0,0,1-4.3-10.942,15,15,0,0,1,1.949-7.67,14.622,14.622,0,0,1,5.594-5.4,15.848,15.848,0,0,1,7.837-2.036,16.59,16.59,0,0,1,12.574,5.768",
    transform: "translate(-2041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1714",
    "data-name": "Trac\\xE9 1714",
    d: "M3037.749,426.686h6.592v-28.6h-6.148v20.4l-1.625-2.211L3022.4,398.059h-6.592v28.627h6.149V406.323l1.632,2.107Z",
    transform: "translate(-2041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1715",
    "data-name": "Trac\\xE9 1715",
    d: "M3051.211,426.686h15.506v-4.944h-9.334V414.8h8.883v-4.944h-8.883v-6.791h9.358V398.09h-15.53Z",
    transform: "translate(-2041)",
    fill: "#312b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1716",
    "data-name": "Trac\\xE9 1716",
    d: "M3089.869,426.686h7.923l-12.431-15.055,11.322-13.469h-7.48l-9.508,12.495h-.222V398.09h-6.164v28.6h6.149V413.525h.253Z",
    transform: "translate(-2041)",
    fill: "#312b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1717",
    "data-name": "Trac\\xE9 1717",
    d: "M3107.942,426.686h6.149V403.035h6.513V398.09h-19.167v4.945h6.5Z",
    transform: "translate(-2041)",
    fill: "#312b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1718",
    "data-name": "Trac\\xE9 1718",
    d: "M3016.031,433.714h7.662v2.575h-4.754v2.52h4.754v2.543h-4.754V447.6h-2.916Z",
    transform: "translate(-2041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1719",
    "data-name": "Trac\\xE9 1719",
    d: "M3039.472,435.5a8.112,8.112,0,0,0-5.64-2.14,8.651,8.651,0,0,0-4.02.98,7.61,7.61,0,0,0-2.95,2.65,6.636,6.636,0,0,0-1.07,3.67,6.842,6.842,0,0,0,2.3,5.14,8.707,8.707,0,0,0,11.42.05,6.646,6.646,0,0,0,2.33-5.15,6.752,6.752,0,0,0-2.37-5.2m-2.02,8.54a5.049,5.049,0,0,1-3.56,1.35,5.363,5.363,0,0,1-3.28-1.04,4.277,4.277,0,0,1-1.84-3.65,4.432,4.432,0,0,1,1.46-3.41,5.092,5.092,0,0,1,3.6-1.34,5.158,5.158,0,0,1,3.62,1.38,3.651,3.651,0,0,1,.28.28,4.552,4.552,0,0,1-.28,6.43",
    transform: "translate(-2041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1720",
    "data-name": "Trac\\xE9 1720",
    d: "M3051.282,441.459a4.425,4.425,0,0,0,2.2-1.39,3.582,3.582,0,0,0,.73-2.29,3.889,3.889,0,0,0-.67-2.29,3.636,3.636,0,0,0-1.75-1.37,11.255,11.255,0,0,0-3.65-.4h-3.11v13.9h2.94v-5.88h.27l3.48,5.9h3.22Zm-.46-2.65a3.854,3.854,0,0,1-1.92.33h-.93l.04-2.85h.79a5.971,5.971,0,0,1,1.58.15,1.455,1.455,0,0,1,.71.48,1.221,1.221,0,0,1,.26.8,1.189,1.189,0,0,1-.53,1.09",
    transform: "translate(-2041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1721",
    "data-name": "Trac\\xE9 1721",
    d: "M3063.833,433.714h7.662v2.575h-4.754v2.52h4.754v2.543h-4.754V447.6h-2.916Z",
    transform: "translate(-2041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1722",
    "data-name": "Trac\\xE9 1722",
    d: "M3074.347,433.714h2.94v11.37h4.278v2.52h-7.218Z",
    transform: "translate(-2041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1723",
    "data-name": "Trac\\xE9 1723",
    d: "M3084.053,433.714h8.423V436.3h-5.507v2.512h5.507v2.543h-5.507v3.661h5.507V447.6h-8.423Z",
    transform: "translate(-2041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1724",
    "data-name": "Trac\\xE9 1724",
    d: "M3095.463,433.714h8.431V436.3h-5.507v2.512h5.507v2.543h-5.507v3.661h5.507V447.6h-8.431Z",
    transform: "translate(-2041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1725",
    "data-name": "Trac\\xE9 1725",
    d: "M3105.352,433.714h8.534v2.607h-2.813V447.6h-2.98V436.321h-2.733Z",
    transform: "translate(-2041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1726",
    "data-name": "Trac\\xE9 1726",
    d: "M3027.472,330.091a4.413,4.413,0,1,1-4.413,4.413,4.413,4.413,0,0,1,4.413-4.413",
    transform: "translate(-2041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1727",
    "data-name": "Trac\\xE9 1727",
    d: "M3027.472,318.927a4.413,4.413,0,1,1-4.413,4.413,4.413,4.413,0,0,1,4.413-4.413",
    transform: "translate(-2041)",
    fill: "#312b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1728",
    "data-name": "Trac\\xE9 1728",
    d: "M3037.883,336.3a4.413,4.413,0,1,1-4.413,4.413,4.413,4.413,0,0,1,4.413-4.413",
    transform: "translate(-2041)",
    fill: "#312b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1729",
    "data-name": "Trac\\xE9 1729",
    d: "M3027.472,341.259a4.41,4.41,0,1,0,4.41,4.41,4.4,4.4,0,0,0-4.41-4.41",
    transform: "translate(-2041)",
    fill: "#312b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1730",
    "data-name": "Trac\\xE9 1730",
    d: "M3037.883,323.879a4.413,4.413,0,1,1-4.413,4.413,4.413,4.413,0,0,1,4.413-4.413",
    transform: "translate(-2041)",
    fill: "#312b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1731",
    "data-name": "Trac\\xE9 1731",
    d: "M3017.061,336.3a4.413,4.413,0,1,1-4.413,4.413,4.413,4.413,0,0,1,4.413-4.413",
    transform: "translate(-2041)",
    fill: "#312b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1732",
    "data-name": "Trac\\xE9 1732",
    d: "M3021.482,328.289a4.42,4.42,0,1,1-4.42-4.42,4.424,4.424,0,0,1,4.42,4.42",
    transform: "translate(-2041)",
    fill: "#312b27"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e09b71488fb4359e153fbc2ec7f48be7.svg";
export { ForwardRef as ReactComponent };